import { ca } from '@cian/analytics';

import { getDeveloperContactsLabel } from 'shared/serp/components/header/developers_contacts';

export function trackSendMessageClick(newbuildingId: number, placeType: string, source?: string) {
  ca('eventSite', {
    action: 'send_message',
    category: 'Listing',
    label: getDeveloperContactsLabel(null),
    name: 'oldevent',
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      extra: {
        type: placeType,
        source,
      },
    },
  });
}
